import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { api, API_BASE } from '../../api/client';

interface Contact {
  id: number;
  address: string;
  phones: string;
  mails: string;
  links: string;
}

const EMPTY: Omit<Contact, 'id'> = { address: '', phones: '', mails: '', links: '' };

export default function AdminContactsPage() {
  const [contact, setContact] = useState<Contact | null>(null);
  const [form, setForm] = useState(EMPTY);
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);

  const load = async () => {
    const r = await axios.get(`${API_BASE}/main-contact/all`);
    if (r.data.length > 0) {
      setContact(r.data[0]);
      setForm(r.data[0]);
    }
  };

  useEffect(() => { load(); }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSaving(true);
    setSaved(false);
    try {
      if (contact) {
        await api.put(`/main-contact/${contact.id}`, form);
      } else {
        await api.post('/main-contact', form);
      }
      await load();
      setSaved(true);
      setTimeout(() => setSaved(false), 3000);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div style={styles.page}>
      <h2 style={styles.title}>Управление контактами</h2>

      <div style={styles.card}>
        <h3 style={styles.cardTitle}>
          {contact ? '✏️ Редактировать контактную информацию' : '➕ Добавить контактную информацию'}
        </h3>

        <form onSubmit={handleSubmit} style={styles.form}>

          <div style={styles.field}>
            <label style={styles.label}>📍 Адрес</label>
            <input
              style={styles.input}
              placeholder="г. Бишкек, ул. Московская 123"
              value={form.address}
              onChange={e => setForm({ ...form, address: e.target.value })}
              required
            />
          </div>

          <div style={styles.field}>
            <label style={styles.label}>📞 Телефоны</label>
            <input
              style={styles.input}
              placeholder="+996 312 123456, +996 312 654321"
              value={form.phones}
              onChange={e => setForm({ ...form, phones: e.target.value })}
              required
            />
            <span style={styles.hint}>Несколько номеров — через запятую</span>
          </div>

          <div style={styles.field}>
            <label style={styles.label}>✉️ Email</label>
            <input
              style={styles.input}
              placeholder="info@health-union.kg, press@health-union.kg"
              value={form.mails}
              onChange={e => setForm({ ...form, mails: e.target.value })}
              required
            />
            <span style={styles.hint}>Несколько адресов — через запятую</span>
          </div>

          <div style={styles.field}>
            <label style={styles.label}>🌐 Веб-сайт / Ссылки</label>
            <input
              style={styles.input}
              placeholder="https://health-union.kg"
              value={form.links}
              onChange={e => setForm({ ...form, links: e.target.value })}
            />
          </div>

          <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
            <button style={styles.btn} type="submit" disabled={saving}>
              {saving ? 'Сохранение...' : '💾 Сохранить'}
            </button>
            {saved && <span style={styles.savedMsg}>✅ Сохранено!</span>}
          </div>
        </form>
      </div>

      {/* Превью */}
      {contact && (
        <div style={styles.preview}>
          <h3 style={styles.previewTitle}>Текущие данные на сайте</h3>
          <div style={styles.previewGrid}>
            <div><strong>Адрес:</strong> {contact.address}</div>
            <div><strong>Телефоны:</strong> {contact.phones}</div>
            <div><strong>Email:</strong> {contact.mails}</div>
            <div><strong>Ссылки:</strong> {contact.links}</div>
          </div>
        </div>
      )}
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  page: { padding: 'clamp(16px, 4vw, 32px)', maxWidth: 700, margin: '0 auto' },
  title: { color: '#1a3a6b', fontSize: 'clamp(1.3rem, 3vw, 1.6rem)', marginBottom: 'clamp(16px, 3vw, 24px)' },
  card: {
    background: '#fff', borderRadius: 10,
    boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
    marginBottom: 20, overflow: 'hidden',
  },
  cardTitle: {
    color: '#1a3a6b', fontSize: 'clamp(0.9rem, 2vw, 1rem)',
    padding: '16px 20px', borderBottom: '1px solid #f0f4fb',
  },
  form: { display: 'flex', flexDirection: 'column', gap: 16, padding: '20px' },
  field: { display: 'flex', flexDirection: 'column', gap: 6 },
  label: { fontWeight: 600, color: '#444', fontSize: '0.9rem' },
  input: {
    padding: '10px 14px', borderRadius: 8,
    border: '1px solid #dde3ef', fontSize: '0.95rem', outline: 'none', width: '100%',
  },
  hint: { fontSize: '0.78rem', color: '#999' },
  btn: {
    padding: '10px 24px', background: '#1a3a6b',
    color: '#fff', border: 'none', borderRadius: 8,
    fontWeight: 600, cursor: 'pointer',
  },
  savedMsg: { color: '#27ae60', fontWeight: 600, fontSize: '0.9rem' },
  preview: {
    background: '#f0f4fb', borderRadius: 10,
    padding: 'clamp(16px, 3vw, 20px) clamp(18px, 4vw, 24px)',
  },
  previewTitle: { color: '#1a3a6b', fontSize: '0.95rem', marginBottom: 14 },
  previewGrid: { display: 'flex', flexDirection: 'column', gap: 8, fontSize: '0.9rem', color: '#444', wordBreak: 'break-word' },
};
